<template>
  <div id="wrapper">
    <SidebarView :accType="true" :addAccType="true" :accTypeVisible="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <b-container>
          <div class="row">
            <div class="py-3 d-flex flex-row align-items-center justify-content-between">
              <div class="col-12">
                <div class="card card-shape home-box">
                  <div class="card-header d-flex flex-row align-items-center">
                    <h6 class="m-0 fw-bold text-green">Update Products Type</h6>
                  </div>
                  <div class="card-body">
                    <form class="form" @submit.prevent="updateData">
                      <account-type-form :form="form" :add_or_edit="add_or_edit" errors="errors"></account-type-form>
                      <hr />
                      <div class="text-center py-3">
                        <button type="submit" :disabled="isSaving"
                          class="btn akkurate-green-btn text-white btn-size my-2 me-2"><font-awesome-icon class="me-2"
                            :icon="['fas', 'save']" />Update</button>
                        <button type="reset" v-if="add_or_edit != 'edit'"
                          class="btn akkurate-gray-btn text-white btn-size my-2 me-2"><font-awesome-icon class="me-2"
                            :icon="['fas', 'rotate-right']" />Reset</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </div>
      <footer></footer>
      <div class="d-none">{{ editAction }}</div>
    </div>

  </div>

</template>
<script>

import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";

import AccountTypeForm from "../form/AccountTypeForm.vue";
import ApiService from "@/core/services/api.service";
import SidebarView from '@/views/main/components/Sidebar.vue';
import TopbarView from '@/views/main/components/Topbar.vue';
import Footer from '@/views/main/components/Footer.vue'

export default {
  components: {
    name: 'CreateAccountType',
    BeatLoaderComponent,
    AccountTypeForm,
    SidebarView,
    TopbarView,
    Footer
  },
  mounted() {

    let token = localStorage.getItem('token');
    if (!token) {
      this.$router.push({ path: '/login' });
    }

  },
  computed: {
    editAction() {
      this.getAccountTypeJson();
    }
  },
  // data() {
  //   return 
  //   {
  //         // this.initialState(),
  //         roles: [],
  //   };
  // },
  data() {
    return {
      ...this.initialState(),
    };
  },
  methods: {
    getAccountTypeJson() {
      // console.log(this.$route.params.id);
      // this.$Progress.start();
      // this.isLoading = true;
      const id = this.$route.params.id;
      ApiService.get(`/accounts/account-types/view/${id}`)
        .then((response) => {
          // console.log(response.data.account_type);
          this.form = response.data.account_type;
          console.log(this.form.charges_coa.coabranch);
          if (response.data.account_type?.coa_subhead?.coahead) {
            this.form.coa_head = response.data.account_type.coa_subhead.coahead;
          }
          // console.log(this.form);
          // console.log(response.data.account_type);
          // this.roles = response.data.roles;
          // this.form.fill(response.data.user);
          // this.form.selected_role = response.data.user.roles[0];
          // this.isLoading = false;
          // this.$Progress.finish();
          // this.isLoading = false;
        })
        .catch((error) => {
          // this.isLoading = false;
          // this.$Progress.fail();
        });
    },
    updateData() {
      this.isSaving = true;
      this.$Progress.start();
      // console.log(this.form);
      ApiService.put(`/accounts/account-types/update/${this.$route.params.id}`, this.form)
        .then((response) => {
          console.log(response);
          this.isLoadingSaving = false;
          this.$Progress.finish();
          toast.fire({
            icon: "success",
            title: response.data.message,
          });
          this.isSaving = false;
          // this.form.reset();
          this.form = this.initialState().form;
          setTimeout(() => {
            window.location.href = '/members/account-type';
          }, '1000');

        })
        .catch((error) => {
          // console.log(error);
          this.isSaving = false;
          this.$Progress.fail();
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });
    },
    initialState() {
      return {
        form: {
          name: "",
          base_type: "",
          withdrawal_allowed: "1",
          deposit_allowed: "1",
          minimum_balance: "",
          send_sms: "1",
          daily_deposit_amount_limit: "4100",
          daily_deposit_frequency_limit: "100",
          daily_withdrawal_amount_limit: "5000",
          daily_withdrawal_frequency_limit: "100",
          unapproved_withdrawal_max_amount: "",
          coa_head: "",
          apply_withdrawal_charges: "0",
          withdrawal_charges_amount: "",
          charges_coa: {
            id: '',
            name: '',
            code: '',
            coabranch: {
              id: '',
              name: '',
              code: ''
            },
          },

        },
        isLoading: true,
        isSaving: false,
        add_or_edit: 'edit',
        errors: []
      };
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>